import styled from '@emotion/styled';

const Container = styled.div`
  font-family: var(--font-Pretendard);
  padding: 0 12px;
`;

export { Container };
